import React from "react";
import { RegionDropdown } from "react-country-region-selector";

const RegionField = ({ label, error, country, handleChange, name, value }) => {
  const stateLabel = window?.post_template.checkout_v4_form?.checkout_v4_formLabels?.tr_checkout_v4_form_stateLabel;
  const isEnhancedContrast = window.enhancedContrast;

  return (
    <div className="input-container">
      <div
        className={`input ${error ? "input--error" : ""} ${isEnhancedContrast && "enhancedContrast"} ${isEnhancedContrast && error && "enhancedContrast__error"}`}
      >
        {label && (
          <span className={`styledLabel styledLabel--active ${isEnhancedContrast && "styledLabel__enhancedContrast"}`}>
            {label}
          </span>
        )}
        <div className="input--customSelect">
          <RegionDropdown
            id="region"
            country={country?.toUpperCase()}
            countryValueType={"short"}
            valueType={"short"}
            value={value}
            defaultOptionLabel={stateLabel}
            autoComplete="address-level1"
            classes={`input--select overflowed-select ${isEnhancedContrast && "enhancedContrast"}`}
            name={name}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </div>
      </div>
      {error && (
        <div className="formError" style={{ marginTop: "4px" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default RegionField;
